const theme = {
  colors: {
    // Core brand palette
    primary:  '#50B4C8',     // Dodger Blue
    secondary: '#E07856',    // Amber
    accent: '#FFD700',       // Gold

    // Neutrals & backgrounds
    background: '#F5F5F5',   // Light Gray base background
    surface: '#FFFFFF',      // Panel/card surfaces
    border: '#E0E0E0',       // Subtle dividers
    text: '#222222',         // Darker default text
    textLight: '#444444',    // Slightly darker secondary text for better contrast
    success: '#4CAF50',      // Success/positive states
    error: '#E53935',        // Error/alert states
    warning: '#FFC107',      // Warning states
    info: '#29B6F6'          // Informational accents
  },

  typography: {
    fontFamily: {
      heading: "'Anton', sans-serif",
      body: "'Rubik', sans-serif",
      mono: "'Roboto Mono', monospace"
    },
    fontSize: {
      xsmall: '0.7rem',
      small: '0.8rem',
      body: '0.9rem',
      large: '1.1rem',
      heading: '1.8rem',
      subheading: '1.3rem'
    },
    fontWeight: {
      light: 300,
      body: 400,
      medium: 500,
      bold: 700,
      heading: 800
    },
    lineHeight: {
      tight: 1.1,
      normal: 1.4,
      relaxed: 1.7
    }
  },

  spacing: {
    xsmall: '4px',
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
    xxlarge: '48px'
  },

  radii: {
    small: '4px',
    medium: '8px',
    large: '12px',
    pill: '999px'
  },

  shadows: {
    subtle: '0 1px 3px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 12px rgba(0, 0, 0, 0.15)',
    strong: '0 8px 24px rgba(0, 0, 0, 0.2)'
  },

  zIndex: {
    dropdown: 1000,
    navbar: 1100,
    modal: 1200,
    toast: 1300
  },

  transitions: {
    fast: '150ms ease-in-out',
    normal: '250ms ease-in-out',
    slow: '400ms ease-in-out'
  }
};

export default theme;
